import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  transform(data: string | any[], char = ','): string {
    if (Array.isArray(data)) {
      return data.join(char);
    } else {
      return data;
    }
  }
}
